import React from 'react';

import {
  EventProvider,
  isEventOffline,
  isVisible,
  useBetslipState,
  useTournamentState,
} from '@atlas/core';
import { EventLink } from '@atlas/routing';
import { EventCompactOutright } from '@atlas/ui';

export function TournamentOutrights() {
  const { events, loading } = useTournamentState();

  const {
    settings: { feeds },
  } = useBetslipState();

  return React.useMemo(() => {
    if (loading) {
      return null;
    }

    const outrightEvents = Object.values(events).filter(
      event => event.outright && isVisible(event),
    );

    if (outrightEvents.length < 1) {
      return null;
    }

    return outrightEvents.map(event => {
      const { source, sportId, sportService } = event;
      const suspended = isEventOffline({ feeds, source, sportId, sportService });

      return (
        <EventProvider event={event} key={event.id}>
          <EventCompactOutright
            EventLink={EventLink}
            className="outright"
            outcomeClassName="primary row"
            suspended={suspended}
          />
        </EventProvider>
      );
    });
  }, [loading, events, feeds]);
}
